import React from 'react';
import { Route, Switch } from 'react-router-dom';

import CustomOrder from '../../pages/Sales/CustomOrderPage/CustomOrderPage';

const SalesRoutes = () => {

  return (
    <Switch>
      <Route path="/sales/custom-order" component={CustomOrder} />
    </Switch>
  );
};

export default SalesRoutes;
